import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { login } from "../store/authSlice"; // Adjust the path if needed
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../Styles/login.css";

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading, error } = useSelector((state) => state.auth);

  // Local state for username, password and role.
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [role, setRole] = useState("admin"); // default role; adjust as needed

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // Dispatch the login thunk with username, password, and role.
      await dispatch(login({ username, password, role })).unwrap();
      toast.success("Login successful!");
      // Navigate to the dashboard or protected route
      navigate("/");
    } catch (err) {
      console.error("Login error:", err);
      toast.error(
        err.detail || "Invalid credentials. Please try again."
      );
    }
  };

  return (
    <div className="loginCover">
      <h1 className="loginHeading">Information Management System</h1>
      <div
        className="login-container"
      >
        <h4>Provide IMS Login Credentials</h4>
        <form onSubmit={handleSubmit}>
          <div className="form-group" >
            <label>Username</label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
          </div>
          <div className="form-group" >
            <label>Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <div className="form-group" >
            <label>Role</label>
            <select
              value={role}
              onChange={(e) => setRole(e.target.value)}
            >
              <option value="masterAdmin">Master Admin</option>
              <option value="admin">Admin</option>
              <option value="sales">Sales</option>
              <option value="trainer">Trainer</option>
            </select>
          </div>
          <button className="loginButton"
            type="submit"
            disabled={loading}
          >
            {loading ? "Logging in..." : "Login"}
          </button>
        </form>
        {error && (
          <p className="error">
            {typeof error === "object" ? JSON.stringify(error) : error}
          </p>
        )}
        <ToastContainer position="bottom-right" autoClose={3000} />
      </div>
      </div>
  );
};

export default Login;
